import { Box, BoxProps, useFormControl } from "@chakra-ui/react";

import { stripDangerousHtml } from "@/lib";

/**
 * Default wrapper to sanitize and render html elements
 * @param html string
 * @returns JSX.Element
 */

export interface HTMLWrapperProps extends BoxProps {
  html: string;
  isFullWidth?: boolean;
}

export function HTMLWrapper(props: HTMLWrapperProps) {
  const { html, className, isFullWidth, ...rest } = props;
  const { required } = useFormControl(rest);

  return (
    <Box
      as={required ? "span" : "div"}
      className={["fr-view", className].filter(Boolean).join(" ")}
      sx={
        required
          ? {
              ">:last-child": { display: "inline" },
              "span.float-left": { float: "left" }
            }
          : { "span.float-left": { float: "left" } }
      }
      width={isFullWidth && !required ? "100%" : "auto"}
      dangerouslySetInnerHTML={{ __html: stripDangerousHtml(html) }}
      {...rest}
    />
  );
}

export default HTMLWrapper;
